import React from "react";
import Operations from "./Operations";
import { activeFilter } from "../../../../../../services/FilteringUtils";
import { labels } from "../../../../../../localization/labels";
import TableUtils from "../../../../../core/Table/TableUtils";
import OperationService from "../../../../../../services/OperationService";
import ControlledTableComponentWithDialog from "../../../../page/ControlledTableComponentWithDialog";
import CommonUtil from "../../../../../../utils/CommonUtil";
import { withKeycloak } from "@react-keycloak/web";

class OperationsContainer extends ControlledTableComponentWithDialog {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      activeFilters: activeFilter,
      operations: []
    };
  }

  initialPageSize() {
    return 5;
  }

  getInheritedDataService() {
    return new OperationService(this.keycloak);
  }

  inheritedDataPropNames = ["entityOperations"];

  _loadAfterArrayDataLoaded = () => {
    this.loadOperations();
  };

  loadOperations = () => {
    const operationsToRemove = this.getInheritedArraySafely(
      this.inheritedDataPropNames[0]
    );

    const pageInfo = this.addPredefinedIdsFilter(
      {},
      operationsToRemove,
      "NOTIN"
    );

    this.prepareCall(
      this.getInheritedDataService().getEntities(
        pageInfo,
        this.sortInfo,
        this.onOperationsLoad,
        this.messageHandler.handleError
      )
    );
    this.performCalls();
  };

  onOperationsLoad = data => {
    this.setState({
      operations: CommonUtil.getDataContent(data) || []
    });
  };

  columns = this.initColumns([
    {
      dataField: "id",
      text: labels.id,
      sort: true,
      classes: "column-id",
      headerClasses: "column-header-id",
      formatter: TableUtils.textFormatter
    },
    {
      dataField: "name",
      text: labels.name,
      headerClasses: "column-header",
      sort: true,
      formatter: TableUtils.textFormatter
    }
  ]);

  possibleSizesPerPage() {
    return [5, 10, 15];
  }

  resetEntity = () => {
    return {
      description: undefined
    };
  };

  validator = entity => {
    return entity ? true : false;
  };

  selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    selectColumnStyle: {
      textAlign: "center"
    },
    headerColumnStyle: {
      textAlign: "center"
    }
  };

  render() {
    return (
      <Operations
        {...this.renderProps()}
        operations={this.state.operations}
        disabled={this.state.disabled}
      />
    );
  }
}

export default withKeycloak(OperationsContainer);
